var React = require('react');

function WatchIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"cx":"9.5","cy":"9","r":"8.25","stroke":"#E8EFFF","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M7.12259 11.6315V6.36852C7.12259 5.56982 8.01273 5.09343 8.67729 5.53647L12.6245 8.16795C13.2182 8.56377 13.2182 9.43623 12.6245 9.83205L8.67729 12.4635C8.01273 12.9066 7.12259 12.4302 7.12259 11.6315Z","fill":"#E8EFFF","key":1})]));
}

WatchIcon.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none"};

module.exports = WatchIcon;

WatchIcon.default = WatchIcon;
